import React from 'react';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import { OfflineExamDefault } from './Default';
import { OfflineExamPlayfulTeacher } from './PlayfulTeacher';

export function OfflineExam(props) {
  const isPlayfulTeacher = usePlayfulTeacher();

  if (isPlayfulTeacher && props.selectedTab === 'provas') {
    return <OfflineExamPlayfulTeacher {...props} />;
  }

  return <OfflineExamDefault {...props} />;
}
